import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditMeetingRequestPayload } from '@app-store/slices/meetingRequests/edit'

interface TaskAction extends Action {
    payload: IEditMeetingRequestPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.edit

function* editMeetingRequestSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.put(`/meeting/meeting-requests/${payload.requestId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError()
    }
}

function* editMeetingRequestSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editMeetingRequestSagaTask)
}

export default editMeetingRequestSaga
